import React, { useState } from "react";
import "./socketOption.scss";
import MuiRadio from "../radio/MuiRadio";

const SocketOptionRadio = ({
  measurement,
  options,
  onChange,
  defaultValue,
  error,
  required,
}) => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <div className="socketOption">
        <MuiRadio
          options={options}
          label="Socket Options"
          defaultValue={defaultValue}
          onChange={handleRadioChange}
          required={required}
          error={error}
        />

        <div>
          {(selectedOption === "156" || defaultValue === 156) && (
            <div className="">{measurement}</div>
          )}
          {(selectedOption === "157" || defaultValue === 157) && (
            <div className="">{measurement}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default SocketOptionRadio;
